export class Var_menu {
    public sharedData :number=-1;
 
    getSharedData(){
       return this.sharedData
    }
 
    updateSharedData(data){
      //Statements 
      this.sharedData=data;
    }
 }